export enum UserType {
  Guest = 0,
  Administrative = 1
}
